import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import services from "../data/services";
import SEO from "./SEO";
import BackLink from "./BackLink";
import "./ServicePage.css";

const ServicePage = () => {
  const { slug } = useParams();
  const service = services.find((item) => item.slug === slug);

  if (!service) {
    return <Navigate to="/" replace />;
  }

  return (
    <article className="service-page">
      <SEO
        title={`${service.title} Berlin und Umgebung | M.F.D. & CO`}
        description={service.detailText.slice(0, 155)}
        url={`https://www.mfd-berlin.com/leistungen/${service.slug}`}
      />
      <BackLink />
      <h1>{service.title} in Berlin und Umgebung</h1>
      <img
        src={service.img}
        alt={`${service.title} in Berlin und Umgebung`}
        width="800"
        height="500"
      />
      <p>{service.detailText}</p>
      <ul>
        {service.points.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
      <Link className="service-page-cta" to="/#kontakt">
        Angebot anfordern
      </Link>
    </article>
  );
};

export default ServicePage;
